import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { breakpoints } from '../../theme';

export const HeaderContainer = styled(Grid)`
  width: 100%;
  height: 80px;
`;

export const HeaderContent = styled(Grid)`
  margin: 0 auto;
  max-width: 1216px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;

  ${({ theme }) => theme.breakpoints.down(breakpoints.desktop)} {
    padding: 0 24px;
  }

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    justify-content: center;
  }
`;
